<template>
	<div class="date-picker-years">
		<div class="date-picker-years__header">
			<Button
				class="btn--icon-only  date-picker-years__previous-btn"
				iconClassName="icon-arrow-left"
				:iconBeforeLabel="true"
				:btnClick="onClickPrevious"
			/>
			<div class="date-picker-years__label">Select a Year</div>
			<Button
				class="btn--icon-only  date-picker-years__next-btn"
				iconClassName="icon-arrow-right"
				:iconBeforeLabel="true"
				:btnClick="onClickNext"
			/>
		</div>
		<List
			class="date-picker-years__list"
			:listItems="yearList"
			@clickPrevious="onClickPrevious"
			@clickNext="onClickNext"
		>
			<template #default="slotProps">
				<Button
					class="date-picker-years__item"
					:id="`${uid}_years`"
					:name="`${uid}_years`"
					:btnClick="() => onClickYear(slotProps.item.year)"
					:labelText="slotProps.item.yearName"
					:selectable="true"
					:selected="slotProps.item.year == value"
				/>
			</template>
		</List>
	</div>
</template>

<script>
import List from '@/components/shells/list/list';
import Button from '@/components/forms/button/button';
import { getYear } from 'date-fns';

export default {
	name: 'DatePickerYears',
	components: {
		List,
		Button
	},
	props: {
		value: {
			type: Number,
			default: () => {
				const currentDate = new Date();
				const currentYear = getYear(currentDate);
				return currentYear;
			}
		},
		startYear: {
			type: Number,
			default: () => {
				const currentDate = new Date();
				const currentYear = getYear(currentDate);
				return currentYear;
			}
		},
		columns: {
			type: Number,
			default: 3
		},
		rows: {
			type: Number,
			default: 4
		}
	},
	data() {
		return {
			currentStartYear: this.startYear,
			displayCount: 0
		};
	},
	created() {
		this.displayCount = this.columns * this.rows;
	},
	computed: {
		yearList() {
			const yearArray = [];

			for (let index = 0; index < this.displayCount; index++) {
				yearArray.push({
					year: this.currentStartYear + index,
					yearName: (this.currentStartYear + index).toString()
				});
			}

			return yearArray;
		}
	},
	methods: {
		onClickPrevious() {
			this.currentStartYear = this.currentStartYear - this.columns;
			this.$emit('clickPrevious');
		},
		onClickNext() {
			this.currentStartYear = this.currentStartYear + this.columns;
			this.$emit('clickPrevious');
		},
		onClickYear(year) {
			this.$emit('input', year);
			this.$emit('change', year);
		}
	}
};
</script>

<style lang="scss" scoped>
.date-picker-years {
	&__header {
		position: relative;
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 32px;
		margin-bottom: $gutter-lg;
		font-size: $default-font-size + 2;
		font-weight: $medium-font-weight;
		text-align: center;
	}

	&__list {
		@include date-picker-list-grid;
	}
}
</style>
